import { Action } from '@ngrx/store';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {AddStreamsCommand, DeleteStreamsCommand} from '../../commands/streams.commands';

export const ADD_STREAMS = '[Streams] ADD_STREAMS';
export const DELETE_STREAMS = '[Streams] DELETE_STREAMS';

export const GET_STREAMS = '[Streams] GET_STREAMS';
export const GET_STREAMS_SUCCESS = '[Streams] GET_STREAMS_SUCCESS';
export const GET_STREAMS_FAILED = '[Streams] GET_STREAMS_FAILED';

export class GetStreamsAction implements Action {
  readonly type = GET_STREAMS;
  constructor() {}
}
export class GetStreamsSuccessAction implements Action {
  readonly type = GET_STREAMS_SUCCESS;
  constructor(public payload: PaymentStreamSetting[]) {}
}
export class GetStreamsFailAction implements Action {
  readonly type = GET_STREAMS_FAILED;
  constructor(public err: any) {}
}

export class AddStreamsAction implements Action {
  readonly type = ADD_STREAMS;
  constructor(public command: AddStreamsCommand) {}
}

export class DeleteStreamsAction implements Action {
  readonly type = DELETE_STREAMS;
  constructor(public command: DeleteStreamsCommand) {}
}

export type StreamsActions =
  GetStreamsAction |
  GetStreamsSuccessAction |
  GetStreamsFailAction |
  AddStreamsAction |
  DeleteStreamsAction;
